/**
 * 状态类：status { success、error、warn }
 * 弹窗类：dialog { toast、alert、confirm }
 * 表单类：from { placeholder、label }
 * 表格类：table { }
 *
 * 接口请求类：request
 * 接口响应类：responce
 *
 * 页面模块类：
 *
 */

// 状态
const state = {
  preheatIng: "Разогрев",
  purchaseIng: "В процессе покупки",
  process: "В процессе",
  over: "Завершено",
  finish: "Завершено",
  noData: "Нет данных",
};

// Верхняя панель на странице покупок и в разделе личных записей о покупках
const subheader = {
  pricePromise: "Гарантия цены, защита от падения",
  vipPrice: "VIP-кэшбэк, выгодная цена",
  protection: "Эксклюзивная защита цены в фиатной валюте",
  pricePromiseVal: "Гарантия цены на [*] дней",
  rewards: "[*]% дохода, гарантированная цена",
  vipDis: "VIP-скидка, успейте",
  zlz: "В процессе поддержки",
};

// Зона покупок
const purchase = {
  periods: "[*] раунд",
  timesSheaves: "Раунд [*]",
  supportPic: "Гарантия цены на [*] дней, защита от падения",
  earnings: "[*]% дохода, гарантированная цена",
  vipDiscount: "VIP-скидка, успейте и получите выгоду",
  limit: "Лимит раунда",
  timeLimit: "Цена со скидкой",
  schedule: "Текущий прогресс",
  finishHalf: "Завершено [*]%",
  subscriptionNum: "Количество покупки",
  vipText: "VIP[*] — скидка ([**] [***] [****]%)", //（VIP6享购买2000COINS 5折）
  supportType: "Механизм гарантии цены: в течение периода гарантии BiKing установит минимальную гарантированную цену для заявок на покупку на вторичном рынке. После окончания периода заявки отменяются.",
  beAbouttoAlipay: "Скоро начнётся",
  atOnceAlipay: "Купить сейчас",
  atOnceAlipayNew: "Поддержать сейчас",
  atOnceAlipayed: "Вы уже участвовали, ждите следующий раунд",
  atOnceAlipayedOver: "Вы уже участвовали, повторное участие невозможно",
  atOnceAlipayedNew: "Вы уже поддержали, ждите следующий раунд",
  atOnceAlipayedNewOver: "Вы уже поддержали, повторное участие невозможно",
  website: "Веб-сайт",
  whitePaper: "Белая книга",
  foreshow: "Анонс покупки",
  startToUp: "Начать покупку",
  startToUpNew: "Начать поддержку",
  distanceStartToUp: "До начала покупки",
  num: "Всего [*] человек купили [**] BAT",
  bannerText: "[*] купил [**] лимита",
  bannerTextNew: "[*] поддержал [**] лимита",
  nextProject: "Ваш лимит выбран, следите за следующим проектом",
  timesText: "Весь лимит раунда выбран. Следующий раунд: [*] месяц [**] день [***]:[****]:[*****]",
  times: "[*] дн. [**] ч [***] мин [****] сек",
  viewDetail: "Подробнее",
  completePawd: "Установите торговый пароль аккаунта",
  sureCoins: "Обеспечьте остаток > [*] [**] (минимальная сумма покупки)",
  sureBalance: "Убедитесь, что баланс [*] > [**]",
  set: "Настроить",
  available: "Доступный лимит",
  holding: "Остаток на счету",
  startSoon: "Покупка скоро начнётся",
  startSoonNew: "Поддержка скоро начнётся",
  projectSupp: "Лимит проекта",
  projectSuppNew: "Лимит поддержки",
  successBuy: "Успешно куплено",
  successBuyNew: "Успешно поддержано",
  projectLimit: "До начала проекта осталось",
  subscription: "Успешно куплено",
  subscriptionNew: "Успешно поддержано",
  projectGoal: "Общий лимит покупки этого проекта",
  projectGoalNew: "Лимит поддержки этого проекта",
  goalFunds: "Завершено покупок",
  goalFundsNew: "Фактическая поддержка достигла цели",
};

// Условия покупки
const purchaseCondition = {
  q: " и ",
  h: " или ",
  cztj: "Обеспечьте сумму пополнения",
  wqyh: "Только для пользователей, не участвовавших в предыдущих акциях",
  vipdj: "Только для VIP[*] и выше",
  condition: "Условия покупки",
  conditionNew: "Условия поддержки",
  nameverify1: "Пройдите KYC для материкового Китая",
  nameverify2: "Пройдите KYC для стран, не входящих в материковый Китай",
  nameverify3: "Пройдите KYC BiKing",
  login: "Войдите в аккаунт",
  maxBuyin: "Максимум покупки",
  verify: "Пройти KYC",
  affirm: "Обеспечьте остаток > [*]",
  myPosition: "Мой остаток",
  AmountOfAscension: "Лимит покупки",
  AmountOfAscensionNew: "Лимит поддержки",
  AmountOfAscensionText: "Чем выше средний дневной остаток [*] за 7 дней до 1-го раунда, тем выше ваш лимит покупки",
  AmountOfAscensionTime: "Мой средний дневной остаток [*] за 7 дней",
  discount: "Скидка на покупку",
  vip_discount: "Скидка на поддержку",
  discountText: "Чем выше VIP, тем ниже цена покупки",
  upgrade: "Повысить уровень",
  vipUpgrade: "Мой VIP",
  zled: "Лимит поддержки",
  wdzl: "Моя поддержка",
  zlxm: "Поддержанный проект",
  mlzl: "Поддержка раунда",
  zlmx: "Детали поддержки",
  ccff: "Первая выдача",
  qgmx: "Детали покупки",

  fjtj: "Дополнительные условия",
  guoji: "Гражданство",
  noJoin: "Не разрешено участвовать",
  wancheng: "Завершить",
  pinggu: "Анкета оценки рисков инвестирования в цифровые валюты",
  cyhd: "Участвовать в акции",
};

// История проектов
const historyProject = {
  rushLimit: "Лимит покупки",
  averagePic: "Средняя цена",
  averageNum: "Количество участников",
};

// Оплата
const alipay = {
  alipaynum: "Количество покупки",
  alipaynumNew: "Лимит поддержки",
  ShouldPay: "К оплате",
  VipDiscounts: "VIP-скидка",
  VipWin: "win-скидка участника",
  willOpen: "Скоро открытие",
  actualPayment: "Фактическая оплата",
  actualPaymentNew: "Поддержка в этом раунде",
  importPassword: "Введите торговый пароль",
  forGetPassword: "Забыли пароль?",
  promptlyAlipay: "Оплатить сейчас",
  purchaseSuccess: "Поздравляем, покупка успешна",
  purchaseSuccessNew: "Поздравляем, поддержка успешна",
  purchaseError: "Ошибка покупки, обновите страницу",
};

// Детали проекта
const projectDetails = {
  text: "Обеспечьте остаток более [*][**]",
  timelimitPic: "Цена со скидкой",
  subscriptionLimit: "Лимит покупки",
  subscriptionLimitNew: "Лимит поддержки",
  preheat: "Разогрев",
  supportAbort: "Окончание гарантии цены",
  unlockAbort: "Время выдачи",
  projectIntroduction: "Описание проекта",
  projectRole: "Правила акции",
  rule: "Правила покупки",
  ruleNew: "Правила поддержки",
};

// Окончание покупки
const purchaseOver = {
  haveSubscribed: "Купленный лимит",
  schedule: "Текущий прогресс",
  Stime: "Время начала покупки",
  StimeNew: "Время начала поддержки",
  Etime: "Время окончания покупки",
  EtimeNew: "Время окончания поддержки",
  successText: "Сбор средств проекта [*] BAT, цель достигнута — успех!",
  success: "Успех",
};

// Мои покупки
const myPurchase = {
  endUnlock: "Разблокировка после последнего раунда покупки",
  endUnlock2: "Выдача после последнего раунда покупки",
  LText: "Ежедневная разблокировка в течение периода гарантии цены",
  WText: "Ежедневная разблокировка вне периода гарантии цены",
  unlockend: "Разблокировано",
  record: "Детали покупки",
  myPurchaseName: "Проекты, в которых я участвую",
};

// Мобильный заголовок
const mHeader = {
  sy: "Главная",
  ksjy: "Быстрая торговля",
  zyjy: "Профессиональная торговля",
  c2c: "C2C",
  otc: "OTC",
  zczx: "Центр активов",
  xwgg: "Новости и объявления",
  xwgg1: "Объявления",
  lc: "BiKing Earn",
  gxlc: "Высокодоходные продукты",
  dxjh: "FansUp!",
  fbjy: "Купить криптовалюту",
  dl: "Войти",
  zc: "Регистрация",
  jtzw: "Упрощённый китайский",
  ftzw: "Традиционный китайский",
  english: "English",
  kr: "한국어",
  qgms: "Лимитированные покупки",
  xsjy: "Потенциальные сделки",
  zczgz: "Общая стоимость активов",
  yhzx: "Личный кабинет",
  wdgl: "Управление ордерами",
  tc: "Выйти",
  dltq: "Зона низкой ликвидности",
  sdgm: "Мгновенная покупка",

  appdown: "Скачать приложение",
  appdown1: "Скачать",
  biking: "Приложение BiKing",
  gfqb: "Официальный кошелёк",
  xzbyapp: "Скачать BiKing App",
  xzbyapp2: "Скачать BiKing App",
  smewm: "Сканировать QR-код",
  xzhyqb: "Скачать HyperPay",
  xzhyqb2: "Скачать HyperPay",
  bbjy: "Спот",
  hyjy: "Бессрочный контракт",
  eftjy: "ETF",
  byb: "Заработок",
  newPos: "Майнинг-пул HBT",
  HyperPay: "HyperPay Earn",
  hqlc: "POS-майнинг",
  newlc: "Заработок",

  dd: "Ордера",
  zichan: "Активы",
  xxzx: "Центр сообщений",
  zhyaq: "Аккаунт и безопасность",
  sfyz: "Верификация",
  wdvip: "Мой VIP",
  apigl: "Управление API",
  hdzx: "Центр акций",
  wdhb: "Мои бонусы",
  flzx: "Центр вознаграждений",
  bitloan: "Крипто-кредит",
  ggjy: "Маржинальная торговля",
  hyxy: "Академия",
  flhd: "Акции",
  bitWin: "BiKing treasure",
};

// Прогресс
const mProgress = {
  dqjd: "Текущий прогресс",
  yjs: "Разблокировано",
};

// Ответы API
const res = {
  seckill_project_000: "Системная ошибка",
  seckill_project_001: "Нет доступных проектов",
  seckill_project_002: "Информация о проекте не найдена",
  seckill_userInfo_001: "Пользователь не существует",
  i18n_no_table_001: "Система перегружена",
  seckill_record_1: "Ошибка оплаты",
  seckill_7days_1: "Правила остатка для этого проекта не найдены",
  seckill_wallet_1: "Системная ошибка",
  seckill_wallet_2: "Недостаточно средств",
  seckill_wallet_3: "Ошибка оплаты",
  seckill_record_count_1: "Ошибка данных",
  seckill_record_count_2: "Ошибка оплаты",
  seckill_record_count_3: "Ошибка оплаты",
  seckill_rounds_1: "Системная ошибка",
  seckill_rounds_2: "В текущем проекте нет активных раундов",
  seckill_rounds_3: "Информация о раундах не найдена",
  seckill_rounds_4: "Системная ошибка",
  seckill_rounds_5: "Информация о выбранном раунде не найдена",
  seckill_pro_1: "Информация о проекте не найдена",
  seckill_pro_2: "Лимит покупки меньше минимального",
  seckill_pro_4: "Системная ошибка",
  seckill_pro_5: "Проект не активен",
  seckill_pay_1: "Системная ошибка",
  seckill_pay_2: "Системная ошибка",
  seckill_pay_3: "Информация о проекте не найдена",
  seckill_pay_4: "Лимит покупки меньше минимального",
  seckill_pay_5: "Лимит покупки превышает остаток раунда",
  seckill_pay_6: "Лимит покупки отсутствует",
  seckill_pay_7: "Сумма покупки превышает лимит",
  seckill_pay_8: "Системная ошибка",
  seckill_pay_9: "Неверный торговый пароль",
  seckill_pay_10: "Ошибка оплаты, повторите попытку",
  seckill_pay_11: "Ошибка оплаты, повторите попытку",
  seckill_pay_12: "Ошибка информации о пользователе",
  seckill_pay_13: "Ошибка оплаты",
  seckill_pay_14: "Неверный торговый пароль",
  seckill_pay_15: "Системная ошибка",
  seckill_pay_16: "Распродано",
  seckill_pay_17: "Слишком много участников, повторите попытку",
  seckill_pay_18: "Вы уже участвовали в этом раунде",
  seckill_pay_19: "Раунд завершён",
  seckill_pay_20: "Войдите в аккаунт",
  seckill_pay_21: "Пройдите KYC",
  seckill_pay_22: "Этот проект только для KYC материкового Китая",
  seckill_pay_23: "Этот проект только для KYC стран, не входящих в материковый Китай",
  seckill_pay_24: "Лимит неверных попыток пароля превышен, попробуйте позже",
  seckill_hold_1: "Ваш остаток [*] не соответствует условиям, пополните и возвращайтесь",
  seckill_survey_submited: "Вы уже заполняли эту анкету",
  seckill_survey_error: "Ошибка обработки анкеты",
  seckill_survey_info: "Анкета для этого проекта не найдена",
};

const addContent = {
  hdjshy: "До окончания акции осталось",
  qgsj: "Время покупки",
  qgsjNew: "Время поддержки",
  gz: "Правила",
  zdjg: "Минимальная цена",
  sq: "Свернуть",
  qgms: "Лимитированные покупки",
  rgxm: "Участие в проекте",
  bled: "Лимит раунда",
  dqjd: "Текущий прогресс",
  yjs: "Разблокировано",
  yff: "Выдано",
  qbcc: "Остаток",
  cg: "Превышает",
  jxmks: "До начала проекта осталось",
  ycgrg: "Успешно куплено",
  cgrg: "Успешно куплено",
  xmed: "Лимит проекта",
  cxmck: "Лимит сбора средств этого проекта",
  ckmb: "Цель сбора достигнута",
  ck: "Сбор средств",
  ckxq: "Подробнее",
  kqed: "Доступный лимит",
  zhcc: "Остаток на счету",
  jjks: "Покупка скоро начнётся",
  mmsz: "Установите торговый пароль",
  qsz: "Настроить",
  qbye: "Убедитесь, что баланс [*] > [**]",
  zjcz: "Обеспечьте остаток > [*] [**] (минимальная сумма покупки)",
  jgdb: "Гарантия цены, защита от падения",
  jgyh: "VIP-кэшбэк, выгодная цена",
  bwbj: "Эксклюзивная защита цены в фиатной валюте",
  bj: "Гарантия цены на [*] дней, защита от падения",
  sybj: "[*]% дохода, гарантированная цена",
  zk: "VIP-скидка, успейте",
  r: "чел.",
  lsxm: "История проектов",
  bpf: "Поддержка сообщества, волна щедрых бонусов",
  syybz: "Низкий порог участия, выгода для всех",
  hg: "Станьте VIP-участником и получайте больше привилегий",
  zgkx: "Максимальная экономия [*] [**]",
  vip_zgkx: "Чем выше уровень VIP, тем больше скидка. Максимум VIP6 — экономия [*][**]",
  vip_zgkxNew: "Чем выше уровень VIP, тем больше скидка на поддержку. Максимум VIP6 — экономия [*][**]",
  blsysj: "Осталось времени в раунде",
  blqbqw: "Весь лимит раунда выбран",
  xyl: "Следующий раунд",
  zskq: "Начнётся точно в срок",
  bljshs: "До окончания покупки осталось",
  zqyc: "Можно участвовать только раз в раунд, возвращайтесь в следующем!",
  zxkf: "У вас нет доступа к этой акции, обратитесь в поддержку",
  zqycNew: "Можно поддержать только раз в раунд, возвращайтесь в следующем!",
  wed: "Ваш лимит покупки в этом проекте = 0, следите за другими проектами",
  wedNew: "Ваш лимит поддержки в этом проекте = 0, следите за другими проектами",
  zsqg: "Минимальная сумма покупки: [*] [**], пополните и возвращайтесь",
  srmm: "Введите торговый пароль",
  smrz: "Пройдите KYC",
  qszjymm: "Сначала установите торговый пароль",
  wenjuandiaocha: "Для участия необходимо заполнить анкету",
  scqgms: "Фестиваль фанатов BiKing",
  hxyh: "Поддержите сообщество BiKing — получайте разнообразные бонусы",
  zsqged: "Минимальная сумма покупки: [*] [**]",
  zsqgedNew: "Минимальная сумма поддержки: [*] [**]",
  wmtj: "Ваш остаток [**] не соответствует условиям, пополните и возвращайтесь",
  qjchqg: "Пополните остаток и возвращайтесь",
  qjchqgNew: "Пополните остаток и возвращайтесь",
  rgjg: "Цена покупки",
  qqg: "Скидка",
  wdqgjl: "Мои записи участия",
  ckxmxq: "Подробнее о проекте",
  t: "дн.",
  yr: "[*] месяц [**] день",
  yrz: "Разогрев раунда [*]",
  qgz: "Покупка раунда [*]",
  djlyjs: "Раунд [*] завершён",
  dj: "VIP-уровень",
  xszk: "Процент скидки",
  jgzked: "Лимит со скидкой",
  zked: "Лимит скидки",
  edw: "Сверх лимита — по обычной цене",
  qbcczd: "Обеспечьте остаток > 1000 CWT (минимальная сумма покупки)",
  qrrjcc: "Средний дневной остаток за 7 дней",
  jlblks: "До начала раунда",
  jlbljs: "До окончания раунда",
  zgkqed: "Максимальный доступный лимит",
  zgkzf: "Максимальная сумма к оплате",
  cggmsl: "Вы ввели количество, превышающее ваш лимит",
  bzzfzxgm: "Недостаточно средств для минимальной покупки",
  bqzdqg: "Минимальная сумма покупки: [*] [**]",
  zlzcLower: "Минимальная сумма поддержки: [*], максимальная: [**]. Токены поддержки будут зачислены в течение 5 рабочих дней после акции.",
  zgqged: "Максимальный лимит: [*] [**]",
  yzbz: "Эксклюзивная скидка для фанатов на качественные монеты",
  xszkj: "Цена со скидкой",
  zlbxsq: "Лимитированная покупка основных монет",
  wks: "Не началось",
  jxz: "В процессе",
  qgsl: "Количество покупки",
  wcydxm: "Проекты, в которых я участвую",
  bjq: "Период котировки",
  hgq: "Период выкупа",
  qzk: "Скидка",
  qxzl: "Будьте первым — получайте токены",
  ds: "Лимит поддержки",
  dhbl: "Курс обмена",
  jicj: "Базовая цена",
  jiagzd: "Финальная цена будет определена за 3 часа до начала покупки",
  zdyh: "Максимальная выгода",
};

const hyy = {
  bkt: "Не открывать",
  wqdkt: "Открыть",
  kt12: "1. До участия вы должны детально изучить основы и риски торговли контрактами, а также правила платформы.",
  kt13: "2. Данный список рисков не является исчерпывающим. Дополнительно оцените иные возможные риски.",
  kt14: "3. Мы рекомендуем вам оценить свою устойчивость к риску и принять взвешенное решение о торговле.",
  kt0: "Уважаемый пользователь:",
  kt1: "У вас ещё нет фьючерсного счёта. Пожалуйста, внимательно прочитайте следующее перед открытием:",
  kt2: "1. При недостатке маржи может произойти принудительная ликвидация позиции BiKing.",
  kt3: "2. Вы должны изучить правила и механизмы работы бессрочных контрактов BiKing.",
  kt4: "3. Позиции переоцениваются в зависимости от рынка. При значительном убытке может произойти ликвидация. Вы несёте ответственность за свои сделки.",
  kt5: "4. В экстремальных рыночных условиях закрытие позиции может быть затруднено (например, при лидерстве по P&L и недостатке страхового фонда).",
  kt6: "5. Существуют регуляторные риски. Изучите законодательство своей юрисдикции. Возможны изменения правил.",
  kt7: "6. Неплатформенные риски (форс-мажор, сбои связи) могут повлиять на исполнение ордеров.",
  kt8: "7. Хеджирование также сопряжено с ценовыми рисками.",
  kta9: "8. Отсутствие верификации или передачи аккаунта может повлиять на безопасность маржи.",
  kta10: "3. В экстремальных рыночных условиях (например, при лидерстве по P&L и недостатке страхового фонда) закрытие позиции может быть недоступно.",
  kt9: "Я внимательно прочитал и принимаю риски",
  kt10: "Активировать фьючерсный счёт",
  zjhz: "Перевод средств",
  ljhz: "Перевести",
  qx: "Отмена",
  khz: "Доступно для перевода",
  qxz: "Выберите",
  bz: "Монета",
  c: "С",
  zz: "На",
  sl: "Количество",
  qb: "Всё",
  ktcg: "Активация успешна",
  ktsb: "Ошибка активации",
  hzcg: "Перевод успешен",
  hzsb: "Ошибка перевода",
  wyyd: "",
  tc: "Выйти",
  warning1: "Выберите монету",
  warning2: "Счёт отправления не может быть пустым",
  warning3: "Счёт назначения не может быть пустым",
  warning4: "Введите сумму не более доступной",
  gb: "Закрыть",
  openSuccess: "Фьючерсный счёт активирован",
  openSuccessTip: "Переведите средства на фьючерсный счёт",
  warning5: "Максимум 4 знака после запятой",
  not_get_nm: "К сожалению, акция с бонусами завершена, при переводе бонус не начислен.",
};

const trading = {
  gflj: "Официальные ссылки",
  gw: "Веб-сайт",
  qkllq: "Обозреватель блоков",
  scfxsj: "Дата первого выпуска",
  fxzl: "Общий объём эмиссии",
  ltzl: "Циркулирующий объём",
  jy: "Торговля",
  sj: "Рыночная",
  tbxx: "Информация на графике",
  bzgk: "Обзор монеты",
  ddb: "Книга ордеров",
  zxcj: "Последние сделки",

  reload: "Обновить",
  socketError: "Ошибка сети,",
  noData: "Нет данных",
  entrustorder: "Стакан",
  prices: "Цена",
  quantity: "Количество",
  grandtotal: "Накоплено",
  transamount: "Объём",
  time: "Время",
  available: "Доступно",
  limitorder: "Лимитный",
  plancommission: "Условный ордер",
  currentcommission: "Активные",
  historycommission: "История ордеров",
  completecommission: "Исполненные",
  funds: "Средства",
  hidetrading: "Скрыть другие пары",
  morecurrentcommission: "Больше активных ордеров",
  morehistorycommission: "Больше истории ордеров",
  moredocommission: "Больше исполненных ордеров",
  realtimetrans: "Сделки в реальном времени",
  myassets: "Мои активы",
  detail: "Детали",
  buyin: "Купить",
  sellout: "Продать",
  login: "Войти",
  transfer: "Перевести",
  recharge: "Пополнить",
  withdrawal: "Вывести",
  quickpurchase: "Быстрая покупка за фиат",
  default: "По умолчанию",
  ordertime: "Время ордера",
  tradingpair: "Торговая пара",
  direction: "Направление",
  types: "Тип",
  commissionprice: "Цена ордера",
  commissionnumber: "Количество в ордере",
  dealprice: "Средняя цена исполнения",
  dealnumber: "Исполненное количество",
  triggerprice: "Цена активации",
  cancelall: "Отменить все",
  averageprice: "Средняя цена",
  totalsum: "Итого",
  fixedprice: "Лимит",
  marketprice: "Рынок",
  codeExpired: "QR-код устарел",
  clickRefresh: "Нажмите для обновления",
  QRsuccessfully: "Сканирование успешно",
  loginInApp: "Пожалуйста, подтвердите вход в приложении",
  backtoQR: "Вернуться к QR-коду",
  loginSuccess: "Вы успешно вошли! Добро пожаловать в Biking!",
  loadingText: "Загрузка...",
  searchPlaceholder: "Поиск",
  all: "Все",
  currency: "Монета",
  price: "Последняя цена",
  market: "Рейтинг роста",
  increase: "Изменение",
  highestPrice: "Максимум",
  minimumPrice: "Минимум",
  turnover: "Объём",
  jydlb: "Список торговых пар",
  bzjs: "Описание монеты",
  currencyTransaction: "Спот",
  leveragedTransaction: "Маржинальная торговля",
  warning:
    "Предупреждение: хардфорк Bitcoin Cash влечёт высокую неопределённость и риски. BiKing не даёт никаких гарантий стоимости форк-токенов!",
  zb: "Индикатор",
  date: "Дата",
  UpAnddown: "Рост/падение",
  amplitude: "Амплитуда",
  0: "Таймфрейм",
  1: "1 мин",
  5: "5 мин",
  15: "15 мин",
  30: "30 мин",
  60: "1 ч",
  240: "4 ч",
  3600: "1 день",
  10800: "1 неделя",
  dates: "Период:",
  password: "Торговый пароль",
  errorPassword: "Введите правильный пароль",
  worningPassword: "Введите пароль",
  cancel: "Отмена",
  sure: "Подтвердить",
  canBuy: "Доступно для покупки",
  canCell: "Доступно для продажи",
  withdraw: "Вывести",
  otc: "OTC — быстрый вход/выход за фиат",
  enterPrice: "Введите цену",
  sellingPrice: "Цена продажи",
  purchasePrice: "Цена покупки",
  salesVolume: "Объём продажи",
  buyingVolume: "Объём покупки",
  volume: "Объём сделки",
  serviceCharge: "Комиссия",
  vip: "Повысьте VIP — получите скидку на комиссию",
  or: "или",
  register: "Регистрация",
  totalPrice: "Объём сделки не может превышать",
  amountTip: "Введите корректное количество",
  amountTipError: "Количество не может превышать",
  limitTrading: "Лимитная торговля",
  priceReminder: "Напоминание о цене",
  SMSReminder: "SMS-уведомление",
  loginAccount: "Войти",
  phone: "Телефон",
  phoneNum: "Введите номер телефона",
  phoneTips: "Неверный номер",
  email: "Эл. почта",
  emailNum: "Введите email",
  emailTips: "﻿Неверный email",
  aears: "Выберите код страны",
  passwordError: "Введите правильный пароль",
  passwordTips: "Введите пароль",
  forgetPassword: "Забыли пароль?",
  noAccount: "Нет аккаунта?",
  goRegister: "Зарегистрироваться",
  appsys: "Вход по QR-коду (безопасно)",
  xzapp: "Скачать последнюю версию приложения",
  mmdl: "Вход по паролю",
  smdl: "Вход по QR-коду",
  google: "Google Authenticator",
  nybd: "Вы привязали",
  zqyzm: "Введите корректный код",
  fsyzm: "Отправить код",
  flv: "Комиссия",
  jz: "Стоимость чистых активов (NAV)",
  jzdesc1:
    "NAV (лонг) = NAV(пред.корр.) * [1 + 3 * (тек.спот цена - пред.спот цена) / пред.спот цена * 100%]",
  jzdesc2:
    "NAV (шорт) = NAV(пред.корр.) * [1 - 3 * (тек.спот цена - пред.спот цена) / пред.спот цена * 100%]",
  sbd: "3x Long",
  sbs: "3x Short",
  flvjs:
    "Комиссия за финансирование ETF взимается ежедневно для покрытия издержек портфеля. Комиссия вычитается из NAV и взимается только в 00:00 (UTC+8). Хранение вне этого времени не облагается комиссией.",
  mzsm: "Отказ от ответственности",
  ido: "Я прочитал и принимаю",
  exemption1: "Уважаемый клиент!",
  exemption2:
    "Продолжая использовать ETF-продукты BiKing, вы подтверждаете, что понимаете риски и принимаете данные условия. Пожалуйста, ознакомьтесь:",
  exemption3: "«Руководство по ETF»",
  exemption4: "Предупреждение о рисках:",
  exemption5:
    "1. Отклонение цены покупки/продажи от NAV может привести к убытку.",
  exemption6:
    "2. При неверном прогнозе в экстремальных условиях цена может стремиться к нулю.",
  exemption7:
    "Все риски, связанные с ETF, ложатся на пользователя. BiKing не несёт ответственности. Данный документ является частью соглашения между BiKing и пользователем.",
  bzjs1: "1. «3L»: при росте базовой цены на 1% NAV растёт на 3%",
  bzjs2: "2. «3S»: при падении базовой цены на 1% NAV растёт на 3%",
  bzjs3: "3. NAV пересчитывается ежедневно в 0:00, при экстремальных движениях — в течение дня.",
  bzjs4: "4. Комиссия за плечо взимается ежедневно.",
  bzjs5:
    "5. Внимание: при экстремальном движении цена ETF может уйти далеко от NAV или стремиться к нулю. Контролируйте риск.",
  gdjk: "Подробнее в объявлениях",
  firstTrading: "Перед первой сделкой установите торговый пароль",
  status: "Статус",
  status1: "В ожидании",
  status2: "Не исполнен",
  status3: "Отменён пользователем",
  status4: "Частично исполнен",
  status5: "Полностью исполнен",
  status6: "Недействителен",
  allCancel: "Отменить выбранные ордера",
  canceld: "Отменить",
  cancelsuccess: "Отменено успешно ({cancelledCount} ордеров)",
  VIP1: "Ваш уровень VIP",
  VIP2: "Более низкие комиссии и лучший опыт",
  VIP3: "Taker:",
  VIP4: "Maker:",
  buyAmount: "Количество покупки не может превышать",
  sellAmount: "Количество продажи не может превышать",
  buyAmountMin: "Недостаточно средств для покупки",
  sellAmountMin: "Недостаточно средств для продажи",
};

const common = {
  wan: "万", // 10k (оставлено иероглифом, т.к. условное обозначение)
  qian: "千", // 1k
  yi: "亿", // 100M
};

const transferDialog = {
  划转: "Перевести",
  资金互转: "Перевод между счетами",
  币币账户: "Спот-счёт",
  买币账户: "Счёт покупки (фиат)",
  已冻结: "Заморожено",
  合约账户: "Фьючерсный счёт",
  未开通: "Не активирован",
  杠杆账户: "Маржинальный счёт",
  币贷宝账户: "Крипто-кредит",
  从: "С",
  转至: "На",
  币种: "Монета",
  数量: "Количество",
  全部: "Все",
  用户未归还借贷的情况下: "Если кредит не возвращён, можно перевести только средства при коэффициенте риска > 200%",
  可划转: "Доступно для перевода",
  一阶: "1. Уровень 1",
  累计净划入: "Чистый перевод",
  可获得: "Можно получить",
  泥码: "Бонус",
  二阶: "2. Уровень 2",
  您尚未完成实名认证: "Вы не прошли верификацию",
  余额: "Баланс",
  立即划转: "Перевести сейчас",
  资产划转: "Перевод активов",
  用于维持现有仓位的保证金: "Маржа для поддержания текущих позиций",
  归还数量: "Сумма возврата",
  您的币贷宝账户尚未开通: "Ваш счёт крипто-кредита не активирован, сначала активируйте",
  请输入正确的数量: "Введите корректное количество",
  划转金额不能为: "Сумма перевода не может быть 0",
  账户可用余额不足: "Недостаточно доступного баланса",
  划转失败: "Ошибка перевода",
  划转成功: "Перевод успешен",
  本次划转未能获得泥码: "К сожалению, акция с бонусами завершена, бонус не начислен",
  您只需再向合约账户划转: "Вам осталось перевести на фьючерсный счёт [*] USDT, чтобы получить [**] USDT бонуса",
  您向合约账户: "Вы перевели на фьючерсный счёт<br/>чистыми [*] USDT и получили",
  请输入划转数量: "Введите сумму перевода",
};

export {
  state,
  subheader,
  purchase,
  purchaseCondition,
  historyProject,
  alipay,
  projectDetails,
  purchaseOver,
  myPurchase,
  mHeader,
  res,
  addContent,
  hyy,
  trading,
  common,
  transferDialog,
};


// WEBPACK FOOTER //
// ./src/i18n/lang/ru.js